import { __assign } from "tslib";
import React, { useMemo } from 'react';
import { Text } from '@keen.io/ui-core';
import { CellContainer, CellContent, TextWrapper } from '../../body-cell';
export var Cell = function (_a) {
    var cell = _a.cell, typography = _a.typography, width = _a.width, isActive = _a.isActive, onCellClick = _a.onCellClick, onCellMouseEnter = _a.onCellMouseEnter, onCellMouseLeave = _a.onCellMouseLeave;
    var _b = cell.value, value = _b.value, formatterType = _b.formatterType;
    var key = cell.getCellProps().key;
    var textAlignment = useMemo(function () {
        var isNumeric = formatterType === 'number' ||
            (typeof value === 'number' && formatterType !== 'string');
        return isNumeric ? 'right' : 'left';
    }, [value, formatterType]);
    return (React.createElement(CellContainer, { key: key, "data-testid": "table-value-cell", isActive: isActive, onClick: function (e) { return onCellClick(e, value); }, onMouseEnter: onCellMouseEnter
            ? function (e) {
                e.persist();
                onCellMouseEnter(e);
            }
            : null, onMouseLeave: onCellMouseLeave
            ? function (e) {
                e.persist();
                onCellMouseLeave(e);
            }
            : null },
        React.createElement(CellContent, { "data-testid": "table-cell-content", textAlignment: textAlignment, width: width },
            React.createElement(TextWrapper, null,
                React.createElement(Text, __assign({}, typography), "" + value)))));
};
